import { put, takeEvery } from "redux-saga/effects";

import { waitForConnection } from "utils";
import {
  fetchBackupSettingsSuccess,
  fetchBackupSettingsFailure,
  saveBackupSettingsSuccess,
  cleanCache,
  showNotificationWithTimeout,
  showNotification,
  updateClientInfo,
  preBackupSettingsChanged,
  fetchClientsStart,
  removeMachineFromHeaderSuccess,
  removeMachineFromHeaderFailure
} from "store/actions";
import * as types from "./types";
import { NOTIFICATIONS, HTTP_EXCEPTION_MESSAGES } from "consts";
import { appInstance } from "axios-config";

export function* fetchBackupSettingsStart(action) {
  try {
    const response = yield appInstance.get("/backup/settings", {
      params: {
        clientUUID: action.clientUUID
      }
    });

    if (response.status === 200) {
      yield put(fetchBackupSettingsSuccess(response.data));
    } else
      yield put(
        fetchBackupSettingsFailure({
          status: response.status,
          msg: response.data
        })
      );
  } catch (error) {
    console.log(error);
  }
}

export function* removeMachineStart(action) {
  try {
    const response = yield appInstance.delete("/backup/list", {
      params: {
        clientUUID: action.clientUUID
      }
    });

    if (response.status === 200) {
      if (action.fromHeader) {
        yield put(removeMachineFromHeaderSuccess());
      } else {
        yield put(
          showNotificationWithTimeout("slidingPopup", {
            status: "success",
            msg: NOTIFICATIONS.removeMachine.success
          })
        );
      }
    } else {
      if (action.fromHeader) {
        yield put(removeMachineFromHeaderFailure());
      } else {
        yield put(
          showNotificationWithTimeout("slidingPopup", {
            status: "failure",
            msg:
              (HTTP_EXCEPTION_MESSAGES[response.data]
                ? HTTP_EXCEPTION_MESSAGES[response.data]
                : response.data) +
              " (" +
              response.status +
              ")",
            httpError: true
          })
        );
      }
    }
  } catch (error) {
    if (action.fromHeader) {
      yield put(removeMachineFromHeaderFailure());
    } else {
      yield put(
        showNotificationWithTimeout("slidingPopup", {
          status: "failure",
          msg: NOTIFICATIONS.removeMachine.failure
        })
      );
    }

    console.log(error);
  }
}

export function* removeMachinesStart(action) {
  try {
    yield action.data.forEach(clientUUID => {
      console.log(clientUUID);
      // const response =  appInstance.delete("/backup/list", {
      //   params: {
      //     clientUUID: action.clientUUID
      //   }
      // });
    });
  } catch (error) {}
}

export function* saveBackupSettingsStart(action) {
  try {
    const response = yield appInstance.post(
      "/backup/settings",
      action.backupSettings,
      {
        params: {
          clientUUID: action.backupSettings.clientDetails.clientUUID,
          srpoint: action.backupSettings.clientDetails.serverIPAddress
            ? action.backupSettings.clientDetails.serverIPAddress
            : ""
        }
      }
    );

    if (response.status === 200) {
      yield put(saveBackupSettingsSuccess());
      yield put(
        showNotificationWithTimeout("slidingPopup", {
          status: "success",
          msg: NOTIFICATIONS.enableMachine.success
        })
      );
    } else {
      yield put(saveBackupSettingsSuccess());
      yield put(
        showNotification("slidingPopup", {
          status: "warning",
          msg:
            (HTTP_EXCEPTION_MESSAGES[response.data]
              ? HTTP_EXCEPTION_MESSAGES[response.data]
              : response.data) +
            " (" +
            response.status +
            ")",
          upgrade: true
        })
      );
    }
  } catch (error) {
    yield put(
      showNotificationWithTimeout("slidingPopup", {
        status: "failure",
        msg: NOTIFICATIONS.enableMachine.failure
      })
    );
    console.log(error);
  }
}

export function* updateBackupSettingsStart(action) {
  yield put(preBackupSettingsChanged(action.clientUUID));
  try {
    const response = yield appInstance.put(
      "/backup/settings",
      action.settings,
      {
        params: {
          clientUUID: action.clientUUID
        }
      }
    );

    if (response.status === 200) {
      if (
        action.settings.scheduleInfo &&
        action.settings.scheduleInfo.scheduleChanged
      )
        yield put(
          updateClientInfo({ nextBackupTime: 0, clientUUID: action.clientUUID })
        );
      yield put(
        showNotificationWithTimeout("slidingPopup", {
          status: "success",
          msg: NOTIFICATIONS.backupSettings.success
        })
      );
      yield put(cleanCache("backupSettings"));
    }
  } catch (error) {
    yield put(
      showNotificationWithTimeout("slidingPopup", {
        status: "failure",
        msg: NOTIFICATIONS.backupSettings.failure
      })
    );
    console.log(error);
  }
}

export function* initiateFullBackup(params) {
  yield takeEvery(types.INITIATE_FULL_BACKUP, action => {
    const req = {
      action: "startForceFullCloudBackup",
      data: { clientUUID: action.clientUUID }
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* addClientsToPlanStart(action) {
  try {
    if (action.isEnableClient) {
      yield put(preBackupSettingsChanged(action.data.devices[0].clientUUID));
    }
    const response = yield appInstance.put(
      "/backupPlan/addclients?srpoint=" +
        (action.srPoint ? action.srPoint : ""),
      action.data
    );
    if (response.status === 200) {
      yield put(saveBackupSettingsSuccess());
      yield put(
        showNotificationWithTimeout("slidingPopup", {
          status: "success",
          msg: NOTIFICATIONS.enableMachine.success
        })
      );
    } else {
      yield put(saveBackupSettingsSuccess());
      yield put(
        showNotification("slidingPopup", {
          status: "warning",
          msg:
            (HTTP_EXCEPTION_MESSAGES[response.data]
              ? HTTP_EXCEPTION_MESSAGES[response.data]
              : response.data) +
            " (" +
            response.status +
            ")",
          upgrade: true
        })
      );
    }
  } catch (error) {
    yield put(
      showNotificationWithTimeout("slidingPopup", {
        status: "failure",
        msg: NOTIFICATIONS.enableMachine.failure
      })
    );
    console.log(error);
  }
}
